<template>
    <div class="page-body">
      <div class="container-fluid">
        <div class="page-title">
          <div class="row">
            <div class="col-6">
              <h3></h3>
            </div>
          </div>
        </div>
        <div class="container-fluid">
          <Loader :loading="isLoading" />
          <loader-component v-if="isLoading" :loading="isLoading" />
          <div class="row">
            <div class="col-sm-12">
              <div class="card">
                <div class="card-body add-post">
                    <div class="row my-3">
                        <!-- Mostrar: dropdown para seleccionar usuarios por página -->
                        <div class="d-flex align-items-center mb-3">
                          <span class="me-2">Mostrar:</span>
                          <select 
                            v-model="itemsPerPage" 
                            @change="resetPagination"
                            class="form-select w-auto px-4 py-[9px] bg-white rounded-md text-black text-sm font-light font-['Poppins'] leading-normal border border-gray-200"
                          >
                            <option :value="10">10</option>
                            <option :value="50">50</option>
                            <option :value="100">100</option>
                          </select>
                          <span class="ms-2">registros</span>
                        </div>
                        <!-- Container para botón y filtros -->
                        <div class="flex flex-col md:flex-row md:justify-between md:items-center w-full mb-4 gap-3">
                          <!-- Botón a la izquierda -->
                          <button @click="goToCompanyForm" 
                            class="px-4 py-2 bg-[#FF4265] text-white text-sm font-medium rounded-md hover:bg-[#e03a5f] transition-colors duration-200 mb-2 md:mb-0">
                            Crear Compañía
                          </button>

                          <!-- Botón toggle filtros (solo mobile) -->
                          <button 
                            @click="showFilters = !showFilters"
                            class="md:hidden px-4 py-2 bg-pink-500 text-white rounded-md flex items-center gap-2 justify-center"
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                            </svg>
                            Filtros
                          </button>

                          <!-- Buscador -->
                          <div class="filters-wrapper w-full md:w-auto" :class="{ 'hidden md:flex': !showFilters, 'flex': showFilters }">
                            <div class="flex flex-col md:flex-row gap-2 w-full md:w-auto">
                              <select 
                                v-model="selectedStatus" 
                                class="px-4 py-[9px] bg-white rounded-md text-neutral-500 text-sm font-light font-['Poppins'] leading-normal border border-gray-200"
                              >
                                <option value="">Todos los estatus</option>
                                <option value="Activo">Activo</option>
                                <option value="Desactivado">Desactivado</option>
                              </select>

                              <!-- Input del buscador -->
                              <input
                                type="text"
                                class="px-4 py-[9px] bg-white rounded-md text-neutral-500 text-sm font-light font-['Poppins'] leading-normal border border-gray-200"
                                placeholder="Buscar"
                                v-model="searchQuery"
                              />
                            </div> 
                          </div> 
                        </div>
                    <div class="row my-3">
                      <div class="w-full ">
                      </div>
                    </div>
                    <div class="overflow-x-auto">
                        <table class="min-w-full bg-white border border-gray-200 rounded-lg shadow-sm">
                            <thead class="bg-gray-50 text-gray-700 uppercase text-xs font-['Poppins']">
                                <tr>
                                <th class="py-3 px-6 text-style-custom text-left">ID</th>
                                <th class="py-3 px-6 text-style-custom text-left">Compañia</th>
                                <th class="py-3 px-6 text-style-custom text-left">Teléfono</th>
                                <th class="py-3 px-6 text-style-custom text-left">Estado</th>
                                <th class="py-3 px-6 text-style-custom text-left">Propiedades</th>
                                <th class="py-3 px-6 text-style-custom text-left">Estatus</th>              
                                <th class="py-3 px-6 text-style-custom text-left">Acciones</th>
                                </tr>
                            </thead>
                            <tbody class="text-gray-700 text-sm divide-y divide-gray-200">
                              <tr
                                v-for="(company, index) in filteredCargos"
                                :key="index"
                                class="hover:bg-gray-50 transition-colors duration-150"
                              >
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap" :class="{'opacity-50':  company.status === 'Desactivado'|| company.status === 'Bloqueado'}">{{ company.id }}</td>
                                <!-- <td class="py-3 px-6 whitespace-nowrap text-sm font-['Poppins']" :class="{'opacity-50':  company.status === 'Desactivado'|| company.status === 'Bloqueado'}">{{ company.name }}</td> -->
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap" :class="{'opacity-50': company.status === 'Desactivado'|| company.status === 'Bloqueado'}">{{ company.name }}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap" :class="{'opacity-50':  company.status === 'Desactivado'|| company.status === 'Bloqueado'}">{{ company.phone }}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap" :class="{'opacity-50':  company.status === 'Desactivado'|| company.status === 'Bloqueado'}">{{ company.state}}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap" :class="{'opacity-50':  company.status === 'Desactivado'|| company.status === 'Bloqueado'}">{{ company.properties_count}}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap">
                                  <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium font-['Poppins']" 
                                    :class="{ 
                                      'bg-red-100 text-red-800': company.status === 'Desactivado',
                                      'bg-green-100 text-green-800': company.status === 'Activo',
                                      'bg-yellow-100 text-yellow-800': company.status === 'Bloqueado'
                                    }">
                                    {{ company.status }}
                                  </span>
                                </td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap">
                                  <div class="relative" ref="el => menuContainers.push(el)">
                                    <!-- Contenedor clickeable -->
                                    <div 
                                      class="flex items-center justify-center w-10 h-10 rounded-full cursor-pointer hover:bg-gray-100 transition-colors duration-150"
                                      @click.stop="toggleMenu(company.id)"
                                    >
                                      <svg 
                                        xmlns="http://www.w3.org/2000/svg" 
                                        width="17" 
                                        height="4" 
                                        viewBox="0 0 17 4" 
                                        fill="none"
                                      >
                                        <path 
                                          fill-rule="evenodd" 
                                          clip-rule="evenodd" 
                                          d="M1.96152 0C3.04429 0 3.92304 0.896031 3.92304 2C3.92304 3.10397 3.04425 4 1.96152 4C0.878748 4 0 3.10397 0 2C0 0.896031 0.878792 0 1.96152 0ZM8.49978 0C9.58255 0 10.4613 0.896031 10.4613 2C10.4613 3.10397 9.58251 4 8.49978 4C7.41705 4 6.53826 3.10397 6.53826 2C6.53826 0.896031 7.41705 0 8.49978 0ZM15.0385 0C16.1213 0 17 0.896031 17 2C17 3.10397 16.1212 4 15.0385 4C13.9557 4 13.077 3.10397 13.077 2C13.077 0.896031 13.9557 0 15.0385 0Z" 
                                          fill="#FF4265"
                                        />
                                      </svg>
                                    </div>

                                    <!-- Menú desplegable -->
                                    <div v-show="menuVisible === company.id" 
                                      class="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-50 overflow-hidden"
                                    >
                                      <div class="py-1 divide-y divide-gray-100">
                                        <!-- Ver perfil -->
                                        <div 
                                          class="px-4 py-2.5 flex items-center hover:bg-gray-50 cursor-pointer text-gray-700 text-sm font-['Poppins'] transition-colors duration-150"
                                          @click="profileCompany(company.id)"
                                        >
                                          <span class="text-sm">Ver Perfil</span>
                                        </div>
        
                                        <!-- Editar -->
                                        <div 
                                          class="px-4 py-2.5 flex items-center hover:bg-gray-50 cursor-pointer text-gray-700 text-sm font-['Poppins'] transition-colors duration-150"
                                          @click="editCargo(company.id)"
                                        >
                                          <span class="text-sm">Editar</span>
                                        </div>
        
                                        <!-- Activar/Desactivar -->
                                        <div 
                                          v-if="company.status === 'Desactivado'"
                                          class="px-4 py-2 flex items-center hover:bg-gray-50 cursor-pointer text-green-600"
                                          @click="confirmActive(company.id)"
                                        >
                                          <span class="text-sm">Activar</span>
                                        </div>
                                        <div 
                                          v-else-if="company.status !== 'Bloqueado'"
                                          class="px-4 py-2 flex items-center hover:bg-gray-50 cursor-pointer text-red-600"
                                          @click="deleteCargo(company.id)"
                                        >
                                          <span class="text-sm">Desactivar</span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                </tr>
                            </tbody>
                        </table>
                      </div>
                      <!-- Vista Mobile - Cards (después del cierre de </table>) -->
                      <div class="lg:hidden flex flex-col gap-4 mt-4">
                        <div v-for="company in filteredCargos" :key="company.id" 
                          class="bg-white border border-gray-200 rounded-lg p-4 shadow-sm"
                          :class="{'opacity-60': company.status === 'Desactivado' || company.status === 'Bloqueado'}">
                          
                          <!-- Header -->
                          <div class="flex justify-between items-start pb-3 mb-3 border-b border-gray-100">
                            <div class="flex-1 space-y-2">
                              <div class="text-gray-900 font-medium text-base font-['Poppins']">{{ company.name }}</div>
                              <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium font-['Poppins']" 
                                :class="{ 
                                  'bg-yellow-100 text-yellow-800': company.status === 'Bloqueado',
                                  'bg-red-100 text-red-800': company.status === 'Desactivado',
                                  'bg-green-100 text-green-800': company.status === 'Activo'
                                }">
                                {{ company.status }}
                              </span>
                            </div>
                            
                            <!-- Menú 3 puntos -->
                            <div class="relative" :ref="el => el && menuContainers.push(el)">
                              <div class="flex items-center justify-center w-10 h-10 rounded-full cursor-pointer hover:bg-gray-100 transition-colors"
                                @click="toggleMenu(company.id)">
                                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="4" viewBox="0 0 17 4" fill="none">
                                  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.96152 0C3.04429 0 3.92304 0.896031 3.92304 2C3.92304 3.10397 3.04425 4 1.96152 4C0.878748 4 0 3.10397 0 2C0 0.896031 0.878792 0 1.96152 0ZM8.49978 0C9.58255 0 10.4613 0.896031 10.4613 2C10.4613 3.10397 9.58251 4 8.49978 4C7.41705 4 6.53826 3.10397 6.53826 2C6.53826 0.896031 7.41705 0 8.49978 0ZM15.0385 0C16.1213 0 17 0.896031 17 2C17 3.10397 16.1212 4 15.0385 4C13.9557 4 13.077 3.10397 13.077 2C13.077 0.896031 13.9557 0 15.0385 0Z" fill="#FF4265"/>
                                </svg>
                              </div>
                              <div v-show="menuVisible === company.id" 
                                class="absolute right-0 mt-2 bg-white border border-gray-200 shadow-lg w-48 z-50 rounded-lg overflow-hidden">
                                <ul class="py-1 divide-y divide-gray-100">
                                  <li class="px-4 py-2.5 hover:bg-gray-50 cursor-pointer text-sm font-['Poppins'] transition-colors" @click="profileCompany(company.id)">Ver Perfil</li>
                                  <li class="px-4 py-2.5 hover:bg-gray-50 cursor-pointer text-sm font-['Poppins'] transition-colors" @click="editCargo(company.id)">Editar</li>
                                  <li v-if="company.status === 'Desactivado' || company.status === 'Bloqueado'" 
                                    class="px-4 py-2.5 hover:bg-gray-50 cursor-pointer text-sm font-['Poppins'] text-green-600 transition-colors" 
                                    @click="confirmActive(company.id)">Activar</li>
                                  <li v-else 
                                    class="px-4 py-2.5 hover:bg-gray-50 cursor-pointer text-sm font-['Poppins'] text-red-600 transition-colors" 
                                    @click="deleteCargo(company.id)">Desactivar</li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          
                          <!-- Body -->
                          <div class="space-y-2">
                            <div class="flex justify-between items-center py-1">
                              <span class="text-gray-500 text-sm font-medium font-['Poppins']">Teléfono:</span>
                              <span class="text-gray-900 text-sm font-['Poppins'] text-right max-w-[60%] break-words">{{ company.phone }}</span>
                            </div>
                            <div class="flex justify-between items-center py-1">
                              <span class="text-gray-500 text-sm font-medium font-['Poppins']">Estado:</span>
                              <span class="text-gray-900 text-sm font-['Poppins'] text-right max-w-[60%] break-words">{{ company.state }}</span>
                            </div>
                            <div class="flex justify-between items-center py-1">
                              <span class="text-gray-500 text-sm font-medium font-['Poppins']">Propiedades:</span>
                              <span class="text-gray-900 text-sm font-['Poppins'] text-right max-w-[60%] break-words">{{ company.properties_count }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <DeleteModal
                        v-if="showModal"
                        :visible="showModal"
                        @close="showModal = false"
                        @confirm="confirmDelete"
                      />
                    <div class="flex justify-between items-center w-full">
                      <div class="hidden md:block w-[278px] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal">
                        Mostrando {{ currentPage }} de {{ totalPages }}
                      </div>
                      <!-- Pagination Controls -->
                      <div class="flex justify-center md:justify-end items-center gap-1 mt-6 py-4">
                        <!-- Botón Anterior -->
                        <button 
                          @click="changePage(currentPage - 1)" 
                          :disabled="currentPage === 1"
                          class="px-3 py-2 border border-[#FFD8DF] bg-white text-[#FF4265] text-sm font-['Poppins'] rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-100 hover:bg-[#FFF5F7] disabled:hover:bg-gray-100 min-w-[40px]"
                        >
                          <span class="hidden md:inline">Anterior</span>
                          <span class="md:hidden">&lt;</span>
                        </button>

                        <!-- Números de página -->
                        <span
                          v-for="(pageNumber, index) in visiblePages"
                          :key="pageNumber === '...' ? `dots-${index}` : `page-${pageNumber}`"
                          class="flex items-center"
                        >
                          <button
                            v-if="pageNumber !== '...'"
                            @click="changePage(pageNumber)"
                            class="px-3 py-2 border border-[#FFD8DF] text-sm font-['Poppins'] rounded transition-colors min-w-[40px]"
                            :class="pageNumber === currentPage 
                              ? 'bg-[#FF4265] text-white border-[#FF4265] font-medium' 
                              : 'bg-white text-[#FF4265] hover:bg-[#FFF5F7]'"
                          >
                            {{ pageNumber }}
                          </button>

                          <span
                            v-else
                            class="px-2 text-gray-500 font-['Poppins']"
                          >
                            ...
                          </span>
                        </span>

                        <!-- Botón Siguiente -->
                        <button 
                          @click="changePage(currentPage + 1)" 
                          :disabled="currentPage >= totalPages"
                          class="px-3 py-2 border border-[#FFD8DF] bg-white text-[#FF4265] text-sm font-['Poppins'] rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-100 hover:bg-[#FFF5F7] disabled:hover:bg-gray-100 min-w-[40px]"
                        >
                          <span class="hidden md:inline">Siguiente</span>
                          <span class="md:hidden">&gt;</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <head>
                      <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap" rel="stylesheet">
                </head>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  
  <script setup>
  import { ref, onMounted, onBeforeUnmount} from 'vue';
  import axios from 'axios';
  import { computed } from "vue";
  import { useStore } from 'vuex';
  import 'vue-toastification/dist/index.css';
  import Loader from '@/components/loaderComponent.vue';
  import DeleteModal from '@/components/company/Modal/DeleteCompanyModal.vue';
  import { useRouter } from 'vue-router';
  
  // Referencias y estado
  const isLoading = ref(true); // Inicializamos isLoading
  //const page = ref(1); // Página actual
  const searchQuery = ref("");  // Para almacenar el término de búsqueda
  const menuVisible = ref(null);
  const store = useStore();
  let session = computed(() => store.getters.getUserSession);
  const company = ref([]); // Aquí guardaremos todos los roles
  //const showDeleteModal = ref(false); // Controla la visibilidad del modal
  const showModal = ref(false); // Controla la visibilidad del modal
  const selectedCargoId = ref(null);
  const selectedStatus = ref("");
  const showFilters = ref(false);
  const router = useRouter();
  const currentPage = ref(1);
  const itemsPerPage = ref(10); // Number of items to show per page
  const menuContainers = ref([]);

  // Métodos
  
  //obtener los cargos
    async function fetchCargos() {
        try {
            let options = {
            headers: {
                'Authorization': `Bearer ${session.value.token_api}`
            }
            };
            const response = await axios.get(
            `${process.env.VUE_APP_API_BASE_URL}/company`, options
            );
            if (response.status === 401) {
            store.dispatch('clearUserSession');
            }
            console.log("Respuesta completa de la API:", response);
            // Accede a los cargos en response.data.cargos
            if (response.status === 200 && response.data?.resp?.companies) {
              company.value = response.data.resp.companies.map(company => ({
                ...company,
                status: translateStatus(company.status), // Traduce el estado de la compañía
              }));
            } else {
              console.error("Error en la respuesta de la API: estructura inesperada");
            }
        } catch (error) {
            console.error("Error al obtener los cargos:", error);
        } finally {
            isLoading.value = false;
        }
    }


    const deleteCargo = (company_id) => {
    selectedCargoId.value = company_id; // Almacena el ID del usuario
    showModal.value = true
  };
  const translateStatus = (status) => {
    const statusTranslations = {
      active: 'Activo',
      disabled: 'Desactivado',
      block: 'Bloqueado',
      pending: 'Pendiente',
      // Agrega más traducciones según sea necesario
    };

    return statusTranslations[status] || status; // Devuelve el estado original si no se encuentra traducción
  };
  const profileCompany = (id) => {
      console.log("ID del rol:", id); // Imprime el ID en la consola
      router.push({ name: 'company-profile', params: { id } }); // Asegúrate de que el nombre coincida con el de la ruta
  };


  const visiblePages = computed(() => {
    const total = totalPages.value;
    const current = currentPage.value;

    const pages = []; // ✅ declarar primero

    if (total <= 4) {
      for (let i = 1; i <= total; i++) {
        pages.push(i);
      }
      return pages;
    }

    pages.push(1);

    if (current > 3) {
      pages.push('...');
    }

    const start = Math.max(2, current - 1);
    const end = Math.min(total - 1, current + 1);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (current < total - 2) {
      pages.push('...');
    }

    pages.push(total);

    return pages;
  });

  async function confirmDelete() {
      try {
        // Configuración de los encabezados
        const options = {
          headers: {
            'Authorization': `Bearer ${session.value.token_api}`
          }
        };

        // Envío de la solicitud con el rol_id
        const data = { company_id: selectedCargoId.value };
        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/company-All-delete`,
          data, 
          options
        );

        // Manejo de la respuesta
        if (response.status === 200) {
          showModal.value = false
          console.log("Cargo eliminado correctamente:", response.data.message);
          fetchCargos();
          return response.data.message; // Mensaje de éxito desde la API
          
        } else {
          console.error("Error en la respuesta de la API: estructura inesperada");
        }
      } catch (error) {
        console.error(
          "Error al intentar eliminar el cargo:",
          error.response?.data?.message || error.message
        );
      }
    }
    const confirmActive = async (company_id) => {
      selectedCargoId.value = company_id; // Almacena el ID del usuario
      try {
        let options = {
          headers: {
            'Authorization': `Bearer ${session.value.token_api}`,
            'Content-Type': 'application/json',
          },
        };
        const data = { company_id: selectedCargoId.value };

        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/company-active`, 
          data, 
          options
        );

        if (response.status === 200) {
          showModal.value = false
          console.log("Cuenta eliminado correctamente:", response.data.message);
          fetchCargos();
          return response.data.message; // Mensaje de éxito desde la API
          
        } else {
          return response.data.message; 
        }
      } catch (error) {
        console.error('Error al activar el usuario', error);
      }
    };
    const goToCompanyForm = () => {
      router.push({ name: 'company-form' });
    };
    const editCargo = (id) => {
      console.log("ID del rol:", id); // Imprime el ID en la consola
      router.push({ name: 'company-form-edit', params: { id } }); // Asegúrate de que el nombre coincida con el de la ruta
    };
    const resetPagination = () => {
      currentPage.value = 1;
    };
    const filteredCargos = computed(() => {
        // Verify if company.value is a valid array
        if (!Array.isArray(company.value)) return [];

        // Filter by search query and status
        let filtered = company.value;

        // Filter by search query
        if (searchQuery.value) {
            filtered = filtered.filter(compani => {
                // Iterate over all properties of 'compani' and check if any contains the search query
                return Object.values(compani).some(value => 
                    value && typeof value === 'string' && value.toLowerCase().includes(searchQuery.value.toLowerCase())
                );
            });
        }

        // Filter by status
        if (selectedStatus.value) {
            filtered = filtered.filter(compani => 
                compani.status === selectedStatus.value
            );
        }

        // Paginate the filtered results
        const start = (currentPage.value - 1) * itemsPerPage.value;
        const end = start + itemsPerPage.value;

        return filtered.slice(start, end);
    });

    const totalPages = computed(() => {
        let filtered = !searchQuery.value
            ? company.value
            : company.value.filter(compani => {
                // Iterate over all properties of 'compani' and check if any contains the search query
                return Object.values(compani).some(value =>
                    value && typeof value === 'string' && value.toLowerCase().includes(searchQuery.value.toLowerCase())
                );
            });

        return Math.ceil(filtered.length / itemsPerPage.value);
    });
    const changePage = (page) => {
      if (page >= 1 && page <= totalPages.value) {
        currentPage.value = page;
      }
    };
     // Manejo de clics fuera del menú
    const handleClickOutside = (event) => {
      // Si el clic no fue dentro de ningún contenedor de menú, cerrar el menú visible
      if (!menuContainers.value.some(container => container?.contains(event.target))) {
        menuVisible.value = null;
      }
    };

    const toggleMenu = (userId) => {
      menuVisible.value = menuVisible.value === userId ? null : userId;
    };
    
  //const showToast = (message) => {
  //successMessage.value = message;
  //setTimeout(() => {
  //  successMessage.value = ''; // Ocultar el mensaje después de 3 segundos
  //}, 3000);
  //};
  // Lifecycle hooks
  onMounted(() => {
  fetchCargos();
  document.addEventListener('click', handleClickOutside);
  });

  onBeforeUnmount(() => {
      document.removeEventListener('click', handleClickOutside);
  });

 
  
</script>
  
<style scoped>
  /* Ocultar tabla en mobile, mostrar cards */
  @media (max-width: 1023px) {
    .overflow-x-auto {
      display: none !important;
    }
  }

  /* Ocultar cards en desktop */
  @media (min-width: 1024px) {
    .lg\:hidden {
      display: none !important;
    }
  }
</style>